import { notifyError } from '../../../../utils/Notify';
import {
  ERROR_TYPES,
  ERROR_CODE_HANDLERS,
  ERROR_MESSAGE_PATTERNS,
  RATE_LIMIT_WAIT_TIME_MINUTES
} from './constantsNumberLogin';


const createRateLimitWaitTime = (minutes = RATE_LIMIT_WAIT_TIME_MINUTES) => {
  const waitTime = minutes * 60 * 1000;
  const endTime = Date.now() + waitTime;
  localStorage.setItem('firebase_retry_after', endTime.toString());
  return waitTime;
};


const handleErrorByCode = (error, codeHandler) => {
  if (codeHandler.needsWaitTime) {
    const waitTime = createRateLimitWaitTime(RATE_LIMIT_WAIT_TIME_MINUTES);
    const minutes = Math.ceil(waitTime / (60 * 1000));
    notifyError(codeHandler.createMessage(minutes));
  } else if (codeHandler.message && !codeHandler.silent) {
    notifyError(codeHandler.message);
  } else if (codeHandler.silent) {
    console.log('Action annulée par l\'utilisateur');
  }
  
  return { success: false, error: codeHandler.type };
};


const handleErrorByMessage = (error, patternHandler) => {
  if (patternHandler.message && !patternHandler.silent) {
    notifyError(patternHandler.message);
  } else if (patternHandler.silent) {
    console.log('Utilisateur a annulé le reCAPTCHA');
  }
  
  return { success: false, error: patternHandler.type };
};


const findErrorPatternHandler = (error) => {
  return ERROR_MESSAGE_PATTERNS.find(patternHandler => 
    patternHandler.patterns.some(pattern => 
      error.message?.includes(pattern)
    )
  );
};


export const handleFirebaseNumberLoginError = (error) => {
  console.error('Erreur durant l\'authentification par numéro:', error);

  const codeHandler = ERROR_CODE_HANDLERS[error.code];
  if (codeHandler) {
    return handleErrorByCode(error, codeHandler);
  }

  const patternHandler = findErrorPatternHandler(error);
  if (patternHandler) {
    return handleErrorByMessage(error, patternHandler);
  }

  notifyError('Erreur lors de l\'envoi du SMS. Veuillez réessayer plus tard.');
  return { success: false, error: error.message };
};


export const handleOTPVerificationError = (error) => {
  console.error('Erreur lors de la vérification OTP:', error);

  const otpErrorHandlers = {
    'auth/invalid-verification-code': {
      message: 'Code de vérification invalide. Veuillez vérifier et réessayer.',
      type: 'invalid_otp'
    },
    'auth/code-expired': {
      message: 'Le code de vérification a expiré. Demandez un nouveau code.',
      type: 'expired_otp'
    },
    'auth/too-many-requests': {
      message: 'Trop de tentatives. Veuillez attendre avant de réessayer.',
      type: ERROR_TYPES.RATE_LIMITED
    }
  };

  const handler = otpErrorHandlers[error.code];
  if (handler) {
    notifyError(handler.message);
    return { success: false, error: handler.type };
  }

  notifyError('Erreur lors de la vérification du code. Veuillez réessayer.');
  return { success: false, error: error.message };
};


export const handleRecaptchaError = (error) => {
  console.error('Erreur reCAPTCHA:', error);

  if (error.message?.includes('timeout')) {
    notifyError('Le délai d\'attente pour le reCAPTCHA a été dépassé. Veuillez réessayer.');
    return { success: false, error: 'recaptcha_timeout' };
  }

  if (error.message?.includes('cancelled')) {
    console.log('reCAPTCHA annulé par l\'utilisateur');
    return { success: false, error: ERROR_TYPES.USER_CANCELLED };
  }

  notifyError('Erreur avec le reCAPTCHA. Veuillez rafraîchir la page et réessayer.');
  return { success: false, error: ERROR_TYPES.RECAPTCHA_ERROR };
}; 